import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {headerAnimationDataProvider as store} from "./header-animation-data-provider";

const headerDesktopAnimation = (tl) => {
    if (!store.isTablet && !store.isMobile) {
        const headerToStickyTl = gsap
            .timeline({
                repeat: 0,
                paused: false,
            })
            .set(store.elements.TOPBAR_ELEMENT, {
                position: "fixed",
                translateY: 0,
                top: 0,
                left: 0,
                width: "100%",
                backgroundColor: "white",
                zIndex: 999,
                opacity: 1,
                ease: "none",
            })
            .set(store.elements.NAVBAR_ELEMENT, {
                position: "fixed",
                translateY: 0,
                top: store.constants.NAVBAR_STICKY_INIT,
                left: 0,
                width: "100%",
                zIndex: 1000,
                backgroundColor: "white",
                opacity: 1,
                ease: "none",
            })
            .to(
                store.elements.TOPBAR_ELEMENT,
                {
                    translateY: "-100%",

                    opacity: 0,
                    ease: "none",
                },
                0,
            )
            .to(
                store.elements.NAVBAR_ELEMENT,
                {
                    top: store.constants.NAVBAR_STICKY_DOWN,

                    opacity: 0,
                    ease: "none",
                },
                0,
            );

        const bookingBarToStickyTl = gsap.timeline({
            repeat: 0,
            paused: false,
        });
        const bookingBarToScrollUpTl = gsap.timeline({
            repeat: 0,
            paused: false,
        });

        const bookingBarScrollUpToInitialPositionTl = gsap.timeline({
            repeat: 0,
            paused: false,
        });

        const pinHeight = store.elementProps.BOOKING_ELEMENT_HEIGHT;
        const destinationNavbarToStickyTl = gsap.timeline({
            repeat: 0,
            paused: false,
            scrollTrigger: {
                trigger: store.elements.DESTINATION_NAVBAR_ELEMENT,
                start: `top +${pinHeight}px`,
                endTrigger: "body",
                end: "bottom +200px",
                // pinReparent: true,
                pin: true,
                pinSpacing: false,
                invalidateOnRefresh: true,
                toggleClass: "--sticky",
                onEnter: () => {
                    store.setDestinationNavbarState("sticky");
                    destinationNavbarToStickyTl.scrollTrigger.refresh();
                },
                onLeaveBack: () => {
                    store.setDestinationNavbarState("initial");
                    destinationNavbarToStickyTl.scrollTrigger.refresh();
                },
            },
        });

        const checkAvailabilityToStickyTl = gsap.timeline({
            repeat: 0,
            paused: false,
            scrollTrigger: {
                trigger: store.elements.CHECK_AVAILABILITY_BTN_TRIGGER,
                start: `top +${pinHeight}px top`,
                endTrigger: "body",
                end: "bottom +200px",
                // pinReparent: true,
                // pin: true,
                // pinSpacing: false,
                invalidateOnRefresh: true,
                // toggleClass: "--sticky",
                onEnter: () => {
                    store.setCheckAvailabilityBtnState("sticky");
                    gsap.to(store.elements.CHECK_AVAILABILITY_BTN_ELEMENT,{
                        y: "0",
                        opacity: 1,
                    });
                },
                onLeaveBack: () => {
                    store.setCheckAvailabilityBtnState("initial");
                    gsap.to(store.elements.CHECK_AVAILABILITY_BTN_ELEMENT, {
                        y: "-250px",
                        opacity: 0,
                    });
                },
            },
        });

        // Add class to destination navbar on scroll up to hide it
        ScrollTrigger.observe({
            debounce: true,
            onUp: () => {
                setTimeout(() => {
                    store.elements.DESTINATION_NAVBAR_ELEMENT?.classList.add("--scroll-up");
                }, 300);

                if (store.currentState.TIMELINE.currentLabel() === "backToTop" || store.currentState.TIMELINE.currentLabel() === "startToSticky") {
                    store.elements.BOOKING_ELEMENT?.classList.remove("--scroll-up");
                } else {
                    store.elements.BOOKING_ELEMENT?.classList.add("--scroll-up");
                }
            },
            onDown: () => {
                setTimeout(() => {
                    store.elements.DESTINATION_NAVBAR_ELEMENT?.classList.remove("--scroll-up");
                }, 300);
            },
        });

        if (store.hasBookingBar) {
            // const destinationNavbarOffset = store.elements?.DESTINATION_NAVBAR_ELEMENT?.getBoundingClientRect().y ?? 0;

            bookingBarToStickyTl
                .set(store.elements.BOOKING_ELEMENT, {
                    position: "fixed",
                    maxWidth: "1219px",
                    width: "80vw",
                    borderRadius: "67px",
                    top: store.constants.BOOKING_STICKY_DOWN,
                    ease: "none",
                })
                .to(
                    store.elements.BOOKING_ELEMENT,
                    {
                        maxWidth: "100%",
                        width: "100vw",
                        borderRadius: "0",
                        top: store.constants.BOOKING_STICKY_DOWN,
                        paddingBottom: "10px",
                        paddingTop: "10px",
                        ease: "none",
                    },
                    0,
                )
                .to(
                    store.elements.SUBMIT_BUTTON,
                    {
                        height: "40px",
                    },
                    0,
                );

            store.elements.DROPDOWN_TOGGLE_ELEMENTS.forEach((element) => {
                bookingBarToStickyTl.to(
                    element,
                    {
                        height: "40px",
                    },
                    0,
                );
            });

            bookingBarToScrollUpTl.to(
                store.elements.BOOKING_ELEMENT,
                {
                    top: store.constants.BOOKING_STICKY_UP,
                    duration: 0.3,
                    ease: "none",
                },
                0,
            );

            bookingBarScrollUpToInitialPositionTl
                .to(
                    store.elements.BOOKING_ELEMENT,
                    {
                        position: "fixed",
                        maxWidth: "1219px",
                        width: "80vw",
                        borderRadius: "67px",
                        top: store.constants.BOOKING_INITIAL,
                        ease: "none",
                        paddingTop: "0",
                        paddingBottom: "0",
                    },
                    0,
                )
                .to(
                    store.elements.SUBMIT_BUTTON,
                    {
                        height: "60px",
                    },
                    0,
                );

            store.elements.DROPDOWN_TOGGLE_ELEMENTS.forEach((element) => {
                bookingBarScrollUpToInitialPositionTl.to(
                    element,
                    {
                        height: "60px",
                    },
                    0,
                );
            });
        }

        const headerToScrollUpTl = gsap
            .timeline({
                repeat: 0,
                paused: false,
            })
            .to(
                store.elements.NAVBAR_ELEMENT,
                {
                    top: store.constants.NAVBAR_STICKY_UP,
                    opacity: 1,
                    duration: 0.3,
                    ease: "none",
                },
                0,
            );

        if (store.elements.CHECK_AVAILABILITY_BTN_ELEMENT) {
            const offset = store.elementProps.NAVBAR_ELEMENT_HEIGHT;
            headerToScrollUpTl.to(store.elements.CHECK_AVAILABILITY_BTN_ELEMENT, {
                y: offset,
                inherit: false
            });
        }

        const headerScrollUpToInitialPositionTl = gsap
            .timeline({
                repeat: 0,
                paused: false,
            })
            .to(
                store.elements.TOPBAR_ELEMENT,
                {
                    translateY: "0",
                    opacity: 1,
                    ease: "none",
                },
                0,
            )
            .to(
                store.elements.NAVBAR_ELEMENT,
                {
                    top: store.constants.NAVBAR_STICKY_INIT,
                    opacity: 1,

                    ease: "none",
                },
                0,
            );

        return (
            tl
                .add(headerToStickyTl, "startToSticky")
                .add(bookingBarToStickyTl, "startToSticky")
                .add(destinationNavbarToStickyTl, "startToSticky")
                .add(checkAvailabilityToStickyTl, "startToSticky")
                .add(headerToScrollUpTl, "stickyToScrollUp")
                .add(bookingBarToScrollUpTl, "stickyToScrollUp")
                // .add(destinationNavbarToScrollUpTl, "stickyToScrollUp")
                .add(headerScrollUpToInitialPositionTl, "scrollUpToInitialPosition")
                .add(bookingBarScrollUpToInitialPositionTl, "scrollUpToInitialPosition")
        );
    }
    return null;
};

export default headerDesktopAnimation;
